/*
 * Vídeo de fondo del Hero.
 *
 * El <video> sale del servidor sin src: aquí se decide cuál cargar (escritorio
 * o móvil) para no descargar los dos. Si no hay JS, si el navegador bloquea el
 * autoplay o si el usuario pide "reducir movimiento", queda la imagen de fondo.
 *
 * En la home hay dos heros, uno oculto en móvil y otro oculto en escritorio
 * (ajuste "Visibilidad"). Un hero oculto sigue estando en el DOM, así que aquí
 * se comprueba que la sección se esté pintando antes de cargar nada: si no,
 * se descargarían los dos vídeos en cada visita.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';

  function isRendered(el) {
    return el.getClientRects().length > 0;
  }

  function play(video) {
    var attempt = video.play();
    if (attempt && attempt.catch) {
      attempt.catch(function () {
        /* Autoplay bloqueado: se queda la imagen de fondo. */
      });
    }
  }

  function watch(video) {
    if (video.dataset.heroVideoWatched === '1') return;
    if (!('IntersectionObserver' in window)) return;
    video.dataset.heroVideoWatched = '1';

    // Pausa el vídeo cuando el hero sale de pantalla o se oculta.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play(video);
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.05 }
    );
    observer.observe(video);
  }

  function init(video) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // La sección puede estar oculta en este breakpoint: no cargar su vídeo.
    if (!isRendered(video)) return;

    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    if (isMobile && video.dataset.disableMobile === '1') return;

    var src = isMobile
      ? video.dataset.srcMobile || video.dataset.srcDesktop
      : video.dataset.srcDesktop || video.dataset.srcMobile;

    if (!src) return;
    if (video.dataset.heroVideoSrc === src) {
      play(video);
      return;
    }

    video.dataset.heroVideoSrc = src;

    video.addEventListener(
      'canplay',
      function () {
        video.classList.add('is-ready');
      },
      { once: true }
    );

    video.src = src;
    video.load();
    play(video);
    watch(video);
  }

  function refresh(video) {
    // La sección puede haberse ocultado al cruzar el breakpoint: pausar.
    if (!isRendered(video)) {
      if (!video.paused) video.pause();
      return;
    }
    init(video);
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll('video[data-hero-video]');
    Array.prototype.forEach.call(videos, refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Al cruzar el breakpoint (girar el móvil, redimensionar), el hero que estaba
  // oculto pasa a verse y hay que cargarlo, y el que se oculta hay que pausarlo.
  // Se escucha resize además de matchMedia porque el evento 'change' no llega
  // en todos los navegadores ni en emulación de dispositivo.
  var pending;
  function onViewportChange() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      boot();
    }, 150);
  }

  var mql = window.matchMedia(MOBILE_QUERY);
  if (mql.addEventListener) {
    mql.addEventListener('change', onViewportChange);
  } else if (mql.addListener) {
    mql.addListener(onViewportChange);
  }
  window.addEventListener('resize', onViewportChange);
  window.addEventListener('orientationchange', onViewportChange);

  // Editor de temas: la sección se vuelve a inyectar al editarla.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
